module.exports = __webpack_public_path__ + "static/img/partner_2.28988e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_2.png
// module id = Up3I
// module chunks = 0